import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ProgressSpinnerComponent } from 'src/app/progress-spinner/progress-spinner.component';
import { AttachmentErrorDialogComponent } from '../../attachment-error-dialog/attachment-error-dialog.component';
import { CloseGrievanceDialogComponent } from '../../close-grievance-dialog/close-grievance-dialog.component';
import { CommonFunction } from '../../common-function';
import { ProjectConstants } from '../../project-constants';

import { ViewattachmentComponent } from '../viewattachment/viewattachment.component';
import { ViewGrievanceService } from './view-grievance.service';

@Component({
  selector: 'app-view-grievance',
  templateUrl: './view-grievance.component.html',
  styleUrls: ['./view-grievance.component.scss'],
})
export class ViewGrievanceComponent implements OnInit {
  myid: any;
  grievanceHistory = [];
  documentList = []
  grievanceId: any;
  boardName: any;
  grievanceType: any;
  id: any;
  progressSpinnerDialog: any = null;
  subject: any;
  remark: any;
  resstatus: any;
  createdOn: any;
  document: any;
  isShowReply: boolean = false;
  closeCheckbox:boolean=false;
  reopenCheckbox:boolean=false;
  docType: string;
  replyCtrl = new FormControl();

  @ViewChild('scrollMe') private myScrollContainer: ElementRef;
  @ViewChild('attachments') attachments: any;
  @ViewChild('attachments1') attachments1: any;
  @ViewChild('attachments2') attachments2: any;
  isShowClose: boolean = false;
  isShowClose1: boolean = false;
  isShowClose2: boolean = false;

  filefirst: boolean = false;
  fileSecond: boolean = false;
  filethird: boolean = false;
  file: File = null;
  file1: File = null;
  file2: File = null;
  filenm: any;
  filenm1: any;
  filenm2: any;
  closeGrievance: any
  reOpenGrievance: any
  fileBase64: any;
  fileBase1_64: any;
  fileBase2_64: any;
  isSubmitDisabled: boolean = false;
  firstFormGroup = this._formBuilder.group({
    replyCtrl: ['', [Validators.required]],
  })

  fileWarningMsg1=ProjectConstants.uiUploadMax3FilesMsg
  fileWarningMsg2=ProjectConstants.uiFileExtensionMsg
  fileWarningMsg3=ProjectConstants.uiFileSizeMsg


  constructor(public viewGrievanceService: ViewGrievanceService,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    public router: Router,
    public commonFunction:CommonFunction,
    public _formBuilder: FormBuilder,
    public activatedRoute: ActivatedRoute) { }

  async ngOnInit() {
    this.showFile()
    //get id through activate route
    this.id = this.activatedRoute.snapshot.paramMap.get('myid');
    // this.id = this.activatedRoute.data.subscribe((data) => {
		// 	const value = data['key']
    // });
    //load grievanceHistory and auto scroll history
    this.loadGrievanceHistory();
    this.scrollToBottom();
  }

  // remove upload
  removeAttachment() {
    if (this.file1 != null) {
      this.file = this.file1
      this.filenm = this.filenm1
      this.fileBase64 = this.fileBase1_64
    if (this.file2 != null) {
        this.file1 = this.file2
        this.filenm1 = this.filenm2
        this.fileBase1_64 = this.fileBase2_64
        this.isShowClose2 = false;
        this.file2 = null
        this.fileBase2_64 = null
        this.filenm2 = null
      } else {
        this.attachments.nativeElement.value = '';
        this.file1 = null
        this.fileBase1_64 = null
        this.filenm1 = null
        this.isShowClose1 = false;
      }
    } else {
      this.attachments.nativeElement.value = '';
      this.file = null
      this.fileBase64 = null
      this.filenm = null
      this.isShowClose = false;
    }
    this.showFile()
  }
  //

  // remove upload
  removeAttachment1() {
    if (this.file2 != null) {
      this.file1 = this.file2
      this.file2 = null
      this.fileBase1_64 = this.fileBase2_64
      this.fileBase2_64 = null
      this.filenm1 = this.filenm2
      this.filenm2 = null
      this.isShowClose2 = false;
    } else {
      this.attachments1.nativeElement.value = '';
      this.isShowClose1 = false;
      this.file1 = null
      this.filenm1 = null
      this.fileBase1_64 = null
    }
    this.showFile()
  }
  //

  // remove upload
  removeAttachment2() {
    this.attachments2.nativeElement.value = '';
    this.isShowClose2 = false;
    this.file2 = null
    this.filenm2 = null
    this.fileBase2_64 = null
    this.showFile()
  }
  //


  //file upload 1
  onChange(event) {
    this.file = event.target.files[0];
    var type = event.target.files[0].type;
    var size = event.target.files[0].size;
    var ext = type.split("/")[1];
    switch (ext) {
      case 'jpg':
      case 'png':
      case 'pdf':
      case 'jpeg':
        if (size <= ProjectConstants.maxFileSize) {
          if (this.file == null) {
            this.isShowClose = false;
            this.filenm = ""
          } else {
            this.filenm = this.file.name
            this.isShowClose = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded.bind(this);
            reader.readAsBinaryString(this.file);
          }
        } else {
          this.file = null;
          this.isShowClose = false;
          this.filenm = ""
          const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
            width: 'fit-content',
            data: { isSize: ProjectConstants.isSizeChecktrue },
          });
          event.target.value = "";
        }

        break;
      default:
        this.file = null;
        const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
          width: 'fit-content',
          data: { isSize: ProjectConstants.isSizeCheckfalse},
        });
        dialogRef.afterClosed().subscribe(async result => {
          var returnval = result;
          event.target.value = "";
          if (this.file == null) {
            this.isShowClose = false;
          } else {
            this.isShowClose = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded.bind(this);
            reader.readAsBinaryString(this.file);
          }
        });
    }
  }
  //

  //file upload 2
  onChange1(event) {
    this.file1 = event.target.files[0];
    var type = event.target.files[0].type;
    var size = event.target.files[0].size;
    var ext = type.split("/")[1];
    switch (ext) {
      case 'jpg':
      case 'png':
      case 'pdf':
      case 'jpeg':

        if (size <= ProjectConstants.maxFileSize) {
          if (this.file1 == null) {
            this.isShowClose1 = false;
            this.filenm1 = ""
          } else {
            this.filenm1 = this.file1.name
            this.isShowClose1 = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded1.bind(this);
            reader.readAsBinaryString(this.file1);
          }
        } else {
          this.file1 = null;
          this.isShowClose1 = false;
          this.filenm1 = ""
          const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
            width: 'fit-content',
            data: { isSize: ProjectConstants.isSizeChecktrue},
          });
          event.target.value = "";
        }


        break;
      default:
        this.file1 = null;
        const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
          width: 'fit-content',
          data: { isSize: ProjectConstants.isSizeCheckfalse},
        });
        dialogRef.afterClosed().subscribe(async result => {
          var returnval = result;
          event.target.value = "";
          if (this.file1 == null) {
            this.isShowClose1 = false;
          } else {
            this.isShowClose1 = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded1.bind(this);
            reader.readAsBinaryString(this.file1);
          }
        });
    }
  }
  //

  //file upload
  onChange2(event) {
    this.file2 = event.target.files[0];
    var type = event.target.files[0].type;
    var size = event.target.files[0].size;
    var ext = type.split("/")[1];
    switch (ext) {
      case 'jpg':
      case 'png':
      case 'pdf':
      case 'jpeg':
        if (size <= ProjectConstants.maxFileSize) {
          if (this.file2 == null) {
            this.isShowClose2 = false;
            this.filenm2 = ""
          } else {
            this.filenm2 = this.file2.name
            this.isShowClose2 = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded2.bind(this);
            reader.readAsBinaryString(this.file2);
          }
        } else {
          this.file2 = null;
          this.isShowClose2 = false;
          this.filenm2 = ""
          const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
            width: 'fit-content',
            data: { isSize: ProjectConstants.isSizeChecktrue },
          });
          event.target.value = "";
        }

        break;
      default:
        this.file2 = null;
        const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
          width: 'fit-content',
          data: { isSize: ProjectConstants.isSizeCheckfalse},
        });
        dialogRef.afterClosed().subscribe(async result => {
          var returnval = result;
          event.target.value = "";
          if (this.file2 == null) {
            this.isShowClose2 = false;
          } else {
            this.isShowClose2 = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded2.bind(this);
            reader.readAsBinaryString(this.file2);
          }
        });
    }
  }

  //base 4 file 1
  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.fileBase64 = btoa(binaryString);
  }
  //

  //base 4 file 2
  _handleReaderLoaded1(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.fileBase1_64 = btoa(binaryString);
  }
  //

  //base 64 file 3
  _handleReaderLoaded2(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.fileBase2_64 = btoa(binaryString);
  }
  //

  //show upload file 1 or 2 or 3
  showFile() {
    if (this.file == null && this.file1 == null && this.file2 == null) {
      this.filefirst = true;
      this.fileSecond = false;
      this.filethird = false;
    } else if (this.file == null && this.file1 == null && this.file2 != null) {
      this.filefirst = true;
      this.fileSecond = false;
      this.filethird = false;
    } else if (this.file == null && this.file1 != null && this.file2 == null) {
      this.filefirst = true;
      this.fileSecond = false;
      this.filethird = false;
    } else if (this.file == null && this.file1 != null && this.file2 != null) {
      this.filefirst = true;
      this.fileSecond = false;
      this.filethird = false;
    }
    else if (this.file != null && this.file1 == null && this.file2 == null) {
      this.filefirst = false;
      this.fileSecond = true;
      this.filethird = false;
    }
    else if (this.file != null && this.file1 == null && this.file2 != null) {
      this.filefirst = false;
      this.fileSecond = true;
      this.filethird = false;
    }
    else if (this.file != null && this.file1 != null && this.file2 == null) {
      this.filefirst = false;
      this.fileSecond = false;
      this.filethird = true;
    }
    else if (this.file != null && this.file1 != null && this.file2 != null) {
      this.filefirst = false;
      this.fileSecond = false;
      this.filethird = false;
    }
  }
  //

  ngAfterViewChecked() {
    this.scrollToBottom();
  }

  //for auto scroll history div
  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) { }
  }
  //

  //load grievance history
  async loadGrievanceHistory() {
    this.documentList = [];
    this.displayProgressSpinner();
    const response: any = await this.viewGrievanceService.loadGrievanceHistoryById(this.id);
    this.progressSpinnerDialog.close();
    if (response != null && !response.error) {
      if (response.status == ProjectConstants.responseStatusSuccess) {
        if (response.tabUserGrievance.length != 0) {
          this.grievanceId = response.tabUserGrievance.pkUsgrid;
          this.boardName = response.tabUserGrievance.boardName;
          this.grievanceType = response.tabUserGrievance.grivType;
          this.subject = response.tabUserGrievance.usGriSubject;
          this.remark = response.tabUserGrievance.usGriDetails;
          this.createdOn = response.tabUserGrievance.createdOn;
          // this.grievanceHistory = response.tabGrievanceHistory.sort((a, b) => a.pkGhid > b.pkGhid ? 1 : -1)
          this.grievanceHistory = response.tabGrievanceHistory.map((item) => {
            if (item.ghDocument1 != null) {
               item.ghDocument1 = item.ghDocument1
            }
            if (item.ghDocument2 != null) {
               item.ghDocument2 = item.ghDocument2
            }
            if (item.ghDocument3 != null) {
               item.ghDocument3 = item.ghDocument3
            }
            return item
          })
      
          this.resstatus = response.tabUserGrievance.statusName;
          this.document = response.tabUserGrievance.usGriDocument1
          if (response.tabUserGrievance.usGriDocument1 != null) {
            this.documentList.push(response.tabUserGrievance.usGriDocument1)
          }
          if (response.tabUserGrievance.usGriDocument2 != null) {
            this.documentList.push(response.tabUserGrievance.usGriDocument2)
          }
          if (response.tabUserGrievance.usGriDocument3 != null) {
            this.documentList.push(response.tabUserGrievance.usGriDocument3)
          }
          if (response.tabUserGrievance.fkStid == 3) {
            this.isShowReply = true;
          }
          if(response.tabUserGrievance.fkStid!=9 && response.tabUserGrievance.fkStid!=5 && response.tabUserGrievance.fkStid!=8){
            this.closeCheckbox=true
          }
          if( response.tabUserGrievance.fkStid==5 || response.tabUserGrievance.fkStid==8){
            this.reopenCheckbox=true
          }
        }
      } else if(response.status==ProjectConstants.responseStatusFailure){
       if(response.code==ProjectConstants.authanticationFailedCode){
        await this.commonFunction.errorToast(ProjectConstants.authanticationFailedMsg,true,"secure/my-grievances")
       }
      }else{
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg,true,"secure/my-grievances")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg,true,"secure/my-grievances")
    }
  }
  //

  //close grievance by mistake
  UpdatecloseGrievance() {
    const dialogRef = this.dialog.open(CloseGrievanceDialogComponent, {
      width: 'fit-content',
      data: { id: 'Close' },
    });
    dialogRef.afterClosed().subscribe(async result => {
      var returnval = result;
      if (returnval == ProjectConstants.noMsg) {
        this.closeGrievance = false
      } else {
        this.closeGrievance = true
        this.displayProgressSpinner();
        const response: any = await this.viewGrievanceService.closeGrievance(this.grievanceId);
        this.progressSpinnerDialog.close();
        if (response != null && !response.error) {
          if (response.status == ProjectConstants.responseStatusSuccess) {
            this.router.navigate(['secure/my-grievances'])
          } else {
            await this.commonFunction.errorToast(ProjectConstants.networkErMsg,true,"secure/my-grievances")
          }
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg,true,"secure/my-grievances")
        }
      }
    });
  }
  //

  //reopen grievance when status is close as grievance
  UpdateReopenGrievance() {
    const dialogRef = this.dialog.open(CloseGrievanceDialogComponent, {
      width: 'fit-content',
      data: { id: 'Reopen' },
    });
    dialogRef.afterClosed().subscribe(async result => {
      var returnval = result;
      if (returnval == ProjectConstants.noMsg) {
        this.reOpenGrievance = false
      } else {
        this.reOpenGrievance = true
        this.displayProgressSpinner();
        const response: any = await this.viewGrievanceService.reopenGrievance(this.grievanceId);
        this.progressSpinnerDialog.close();
        if (response != null && !response.error) {
          if (response.status == ProjectConstants.responseStatusSuccess) {
            this.router.navigate(['secure/my-grievances'])
          } else {
            await this.commonFunction.errorToast(ProjectConstants.networkErMsg,true,"secure/my-grievances")
          }
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg,true,"secure/my-grievances")
        }
      }
    });
  }
  //

  //reply to support user if and only if status is waiting for customer input
  async replyTosupport() {
    if (this.firstFormGroup.valid) {
      if (this.filenm != null) {
        var file1_extension = '.' + this.filenm.split('.')[this.filenm.split('.').length - 1]
      }
      if (this.filenm1 != null) {
        var file2_extension = '.' + this.filenm1.split('.')[this.filenm1.split('.').length - 1]
      }
      if (this.filenm2 != null) {
        var file3_extension = '.' + this.filenm2.split('.')[this.filenm2.split('.').length - 1]
      }
      const data = {
        ghRemark:this.firstFormGroup.controls['replyCtrl'].value,
        fkUsGriid: this.id,
        file1: this.fileBase64,
        file1Ext: file1_extension,
        file2: this.fileBase1_64,
        file2Ext: file2_extension,
        file3: this.fileBase2_64,
        file3Ext: file3_extension,
        'file1Name': this.filenm,
        'file2Name': this.filenm1,
        'file3Name': this.filenm2
      }

      this.displayProgressSpinner();
      const response: any = await this.viewGrievanceService.replyGrievance(data);
      this.progressSpinnerDialog.close();
      if (response != null && !response.error) {
        if (response[0].status == ProjectConstants.responseStatusSuccess) {
          await this.commonFunction.successToast(ProjectConstants.replySucessMsg, true, "secure/my-grievances")
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg,true,"secure/my-grievances")
        }
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg,true,"secure/my-grievances")
      }
    }
  }
  //


  //after reply go back to grievance list
  gotoList() {
    this.router.navigate(['secure/my-grievances'])
  }
  //

  //view attached document when click on eye icon
  async ViewdownloadAttachment(ghDocument) {
    if (ghDocument.split(".")[1] == 'jpg' || ghDocument.split(".")[1] == 'jpeg' || ghDocument.split(".")[1] == 'png') {
      this.docType = "image/" + ghDocument.split(".")[1]
    } else if (ghDocument.split(".")[1] == 'pdf') {
      this.docType = "application/pdf"
    }
    this.displayProgressSpinner();
    const response: any = await this.viewGrievanceService.downloadAttachment(ghDocument);
    this.progressSpinnerDialog.close();
    if (response != null && !response.error) {
      if (response.status == ProjectConstants.responseStatusSuccess) {
        const dialog = this.dialog.open(ViewattachmentComponent, {
          disableClose: true,
          width: "600px",
          data: [response.imgResponseString, this.id, this.docType,ghDocument]
        });
      }else if(response.status==ProjectConstants.responseStatusFailure) {
        if(response.code==ProjectConstants.noAbleToDownloadErCode){
          await this.commonFunction.errorToast(ProjectConstants.noAbleToDownloadErMsg,false,"")
        }else{
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg,true,"secure/my-grievances")
        }
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg,true,"secure/my-grievances")
    }
  }
  //

  //loader
  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }
  //

  //download attached document directly
  async downloadAttachment(ghDocument) {
    if (ghDocument.split(".")[1] == 'jpg' || ghDocument.split(".")[1] == 'jpeg' || ghDocument.split(".")[1] == 'png') {
      this.docType = "image/" + ghDocument.split(".")[1]
    } else if (ghDocument.split(".")[1] == 'pdf') {
      this.docType = "application/pdf"
    }
    this.displayProgressSpinner();
    const response: any = await this.viewGrievanceService.downloadAttachment(ghDocument);
    this.progressSpinnerDialog.close();
    if (response != null && !response.error) {
      if (response.status == ProjectConstants.responseStatusSuccess) {
        const byteArray = new Uint8Array(
          atob(response.imgResponseString)
            .split("")
            .map((char) => char.charCodeAt(0))
        );
        let blob = new Blob([byteArray], { type: this.docType });
        var src = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = src;
        const date = new Date().toDateString(),
        time = new Date().getTime()
        link.download = this.id+ "_" +date+"_"+time+
        '.' + ghDocument.split('.').pop();
        link.click();
        await this.commonFunction.successToast(ProjectConstants.fileSuccessToastMsg,false,"")
      }else if(response.status==ProjectConstants.responseStatusFailure) {
        if(response.code==ProjectConstants.noAbleToDownloadErCode){
          await this.commonFunction.errorToast(ProjectConstants.noAbleToDownloadErMsg,false,"")
        }else{
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg,true,"secure/my-grievances")
        }
      }
      else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg,true,"secure/my-grievances")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg,true,"secure/my-grievances")
    }
    //
  }

  
}
